(function() {
    'use strict';
    angular
    .module('MW.CoreStream.ComposeMedialists', [
                'MW.Framework.CoreCompanyService',
                'MW.Influencers.IcmDialogService'
         ])
        .directive('composeMedialists',function() {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/partials/outreach_compose_medialists_dialog',
                scope: {
                   allMediaLists: '=?',
                   preSelectedMediaLists: '=?',
                   recipientsLabel: '=?',
                   callbackMethod: '&?'
                },
                controller: ComposeMedialistsController,
                controllerAs: 'composeMedialistsController'
            };
        })
        .controller('composeMedialistsController', [
            'CoreCompanyService',
            'DialogService',
            'DEFAULT_MEDIA_LIST',
            '$scope',
            ComposeMedialistsController
        ]);

    function ComposeMedialistsController(CoreCompanyService, DialogService, DEFAULT_MEDIA_LIST, $scope) {
         this.preSelectedMediaLists = $scope.preSelectedMediaLists;
         this.recipientsLabel = $scope.recipientsLabel;
         this.callbackMethod = $scope.callbackMethod;
         this.allMediaLists = $scope.allMediaLists;

         this.DialogService = DialogService;

         this.mediaLists = [];
         this.selectedMediaLists = {};

         //TODO - Remove at some point, since we don't need this list to be here any longer
         this.defaultListName = DEFAULT_MEDIA_LIST + (this.companyId ? this.companyId : CoreCompanyService.getId());
         this.mediaLists = this.allMediaLists;
         this.selectedMediaListsObject = {};
         this.removedMediaListsObject = {};
         this.shouldDisableSave = true;
         this.recipientsLabel = this.recipientsLabel.substring(this.recipientsLabel.lastIndexOf('(')+1,this.recipientsLabel.lastIndexOf(')')) + '.';

         Object.keys(this.preSelectedMediaLists).forEach(function(key) {
             this.selectedMediaLists[key] = true;
             this.selectedMediaListsObject[key] = this.preSelectedMediaLists[key];
             this.shouldDisableSave = false;
         }.bind(this));
    }

    ComposeMedialistsController.prototype.toggleSelection = function toggleSelection(mediaListId, mediaList){
        if(this.selectedMediaLists[mediaListId]){
            delete this.selectedMediaLists[mediaListId];
            delete this.selectedMediaListsObject[mediaListId];
            if(this.preSelectedMediaLists[mediaListId]) {
                this.removedMediaListsObject[mediaListId] = mediaList;
            }

        } else {
            this.selectedMediaLists[mediaListId] = true;
            this.selectedMediaListsObject[mediaListId] = mediaList;
            delete this.removedMediaListsObject[mediaListId];
        }

        if(Object.keys(this.selectedMediaLists).length > 0 || Object.keys(this.preSelectedMediaLists).length > 0) {
            this.shouldDisableSave = false;
        } else {
            this.shouldDisableSave = true;
        }
    };

    ComposeMedialistsController.prototype.save = function save(){
        this.selectedMediaListsObjectArray = [];
        Object.keys(this.selectedMediaListsObject).forEach(function(key) {
            if(!this.preSelectedMediaLists[key]) {
                this.selectedMediaListsObjectArray.push(this.selectedMediaListsObject[key]);
            }
        }.bind(this));
        this.callbackMethod({selectedMediaListsArray: this.selectedMediaListsObjectArray, removedMediaLists: this.removedMediaListsObject});
        this.DialogService.closeDialog();
    };

    ComposeMedialistsController.prototype.cancel = function cancel(){
        this.DialogService.closeDialog();
    };

}());
